import * as React from 'react'
import InputField from '../../common/components/input-field'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import QueryString from 'query-string'
import checkOptions from '../../common/options/check-options'
import { getQueryString } from '../../common/util'

import { withProductDataDefered } from '../../common/modules/product-data'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withState } from '../../common/modules/state'
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    const fields = state.fields;

    
    return {
        
        rules: {
            "requester.firstName":[
                Validation.enforce.required("Please enter your first name."),
            ],
            "requester.surname":[
                Validation.enforce.required("Please enter your last name."),
            ],
            "requester.email":[
                Validation.enforce.required("Please type a valid email address"),
                Validation.enforce.email("Please type a valid email address.")
            ],
            "requester.phone":[
                Validation.enforce.required("Please type a valid phone number."),
            ],
            "recaptcha":[
                Validation.enforce.required(""),
            ]
        },

        predicates:{},
        options:{},
        inferred:{},
        
        transformOut: data => {
            const referenceCode = getQueryString().referenceCode ? getQueryString().referenceCode.trim() : "";
            return referenceCode
                ? { ...data, referenceCode }
                : data
        }
    }
}

@withSubmission
@withNavigation
@withValidation
@withRouteBlocker
@withProductDataDefered
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {

    componentWillMount() {
        const queryString = getQueryString();
        const firstName = queryString.firstName ? queryString.firstName : "" ;
        const surname = queryString.lastName ? queryString.lastName : "" ;
        const phone = queryString.phone ? queryString.phone : "" ;
        const email = queryString.email ? queryString.email : "" ;

        // set STEP-1 details for prepopulating query string parameters
        if (firstName) 
            this.props.actions.fields.updateField("requester.firstName", firstName);
        if (surname)
            this.props.actions.fields.updateField("requester.surname", surname);
        if (phone)
            this.props.actions.fields.updateField("requester.phone", phone);
        if (email)
            this.props.actions.fields.updateField("requester.email", email);
    }

    render() {
        const fields = this.props.fields;

        return (   
            <div className="row">
                <StepTitle>Let's get started</StepTitle>

                <StepBlock>
                    <p>Tell Us About Your Personal Information</p>
                </StepBlock>

                <InputField  field="requester.firstName" label="First name" />
                <InputField  field="requester.surname"   label="Last name" />
                
                <SubHeader>How can we contact you?</SubHeader>
                
                <InputField  field="requester.phone"  type="tel"     label="Phone"       description="Please include area code if you're providing a landline e.g. 0298765432" />
                <InputField  field="requester.email"  type="email"   label="Email"       description="This will allow us to forward you the quote and to retrieve it in the future." />


                <StepBlock>
                    <p>By continuing with this quote you agree that the right <a href ='https://www.chu.com.au/important-documents/' target="_blank"><strong>PDS</strong></a> has been made available to you; you have read and agree with our <a href='https://www.chu.com.au/privacy-policy/' target="_blank"><strong>Privacy Policy</strong></a>, <a href='https://www.chu.com.au/legal-notices/'  target="_blank"><strong>Legal Notices</strong></a> & <a href='https://www.chu.com.au/resource/duty-to-not-misrepresent' target="_blank"><strong>Duty to not misrepresent </strong></a> and consent to receiving policy documents via electronic means and relevant CHU Underwriting Agencies marketing communications.</p>
                </StepBlock>
                
                <Recaptcha field="recaptcha"/>

                { fields.recaptcha &&
                    <Button.Container>
                        <Button.Continue onClick={ this.validate.bind(this) } />
                    </Button.Container>
                }
            </div>
        )
    }


    validate(){
        console.log("Validate")
        this.props.actions.validation.validate( this.submit.bind(this) );
    }


    submit(){
        const endpoint = this.props.submission.endpoints.quoteSetup;
        this.props.actions.submission.submit(endpoint, this.requestProductData.bind(this), [
            require('./step-1').formConfig
        ] );
    }


    requestProductData(){
        const token = this.props.fields.token;
        const endpoint1 = this.props.submission.endpoints.template;
        this.props.actions.submission.get(endpoint1+"?token="+ token, this.templatePrefill.bind(this), this.renameFields.bind(this));    
    }

    templatePrefill(){
        this.props.actions.productData.requestProductData(this.proceed.bind(this))
    }

    proceed(){
        this.props.actions.navigation.changeRoute("/step-2")
    }

    renameFields(data){
        // The below variables are created to support the query parameters and prefill the form values.
        const queryString = getQueryString();
        const currentInsurer = queryString.currentInsurer;
        const otherInsurer = queryString.otherInsurer;
        const currentExcess = queryString.currentExcess;
        const numberOfClaims = queryString.noOfClaims;
        const valueOfClaims = queryString.valueOfClaims;
        const propertyInsuranceDeclined = queryString.propertyDeclined;
        const coverLimited = queryString.coverLimited;
        const streetNumber = queryString.streetNumber;
        const streetName = queryString.streetName;
        const suburb = queryString.suburb;
        const state = queryString.state;
        const postcode = queryString.postcode;
        const ownersCorporationNumber = queryString.ownersCorpNum;
        const ownersCorporationType = queryString.ownersCorpType;
        const selfManaged = queryString.selfManaged;
        const buildingSumInsured = queryString.bsi;
        const contentsSumInsured = queryString.csi;
        const lossOfRentPercent = queryString.lossOfRentPercent;
        const liabilitySumInsured = queryString.lsi;
        const voluntaryWorkersDeath = queryString.vwDeath;
        const workersCompensationRequired = queryString.wcRequired;
        const estimatedWages = queryString.wcEWages;
        const employeesEstimatedWages = queryString.wcEEWages;
        const labourOnlyEstimatedWages = queryString.wcLOEWages;
        const labourMaterialsEstimatedWages = queryString.wcLMEWages;
        const labourPlantEstimatedWages = queryString.wcLPEWages;
        const labourPlantMaterialsEstimatedWages = queryString.wcLPMEWages;
        const fidelitySumInsured = queryString.fsi;
        const cyberSumInsured = queryString.cysi;
        const officeBearersRequired = queryString.obRequired;
        const officeBearersSumInsured = queryString.obsi;
        const machineryBreakdownRequired = queryString.mbRequired;
        const machineryBreakdownSumInsured = queryString.mbsi;
        const carStackerTurnTable = queryString.mbTurnTable;
        const airConditioningLocation = queryString.mbACLocation;
        const electronicMotors5KW = queryString.mbEMotors;
        const chillersOrCoolingTowers = queryString.mbChillers;
        const twentyYearOldPlus = queryString.mbTwentyPlus;
        const catastropheRequired = queryString.caRequired;
        const catastrophePercent = queryString.caPercent;
        const floodRequested = queryString.floodRequested;
        const buildingName = queryString.buildingName;
        const yearBuilt = queryString.yBuilt;
        const yearRewired = queryString.yRewired;
        const yearReplumbed = queryString.yReplumbed;
        const yearRefurbished = queryString.yRefurbished;
        const heritageListed = queryString.heritage;
        const numberOfLots = queryString.noOfLots;
        const numberOfResidentialLots = queryString.numberOfResidentialLots;
        const numberOfFloors = queryString.noOfFloors;
        const numberOfBasements = queryString.noOfBasements;
        const equipmentInBasements = queryString.equipments;
        const commerciallyUsed = queryString.commerciallyUsed;
        const knownDefects = queryString.knownDefects;
        const wallConstruction = queryString.wallConstruction;
        const roofConstruction = queryString.roofConstruction;
        const floorConstruction = queryString.floorConstruction;
        const epsPercent = queryString.epsPercent;
        const aluminiumCompositePanels = queryString.acPanels;
        const numberOfLifts = queryString.noOfLifts;
        const numberOfPoolsOrSpas = queryString.noOfPools;
        const hasPlayground = queryString.hasPlayground;
        const jettyWharfPontoonMarina = queryString.jetty;
        const lakePondWaterway = queryString.waterway;
        const gymUsedByPublic = queryString.gymUsedByPublic;
        const fullyOccupied = queryString.fullyOccupied;
        const groundFloorOccupancy = queryString.gfOccupancy;
        const fireExtinguishers = queryString.fExtinguishers;
        const fireHydrantsHoseReels = queryString.fHydrants;
        const fireAlarm = queryString.fAlarm;
        const sprinklersLocation = queryString.sprinklersLocation;
        const strataManagementCompanyName = queryString.smCompanyName;
        const strataManagerContactFullName = queryString.smFullName;
        const strataManagerContactPhone = queryString.smPhone;
        const strataManagerContactEmail = queryString.smEmail;
        const propertyExcess = queryString.pExcess;
        const waterDamageExcess = queryString.wdExcess;
        const lotOwnerContentsSumInsured = queryString.lotOwnerContentsSumInsured;

        // set STEP-2 details
        if (currentInsurer) data.currentInsurer = currentInsurer;
        if (otherInsurer) data.otherInsurer = otherInsurer;
        if (currentExcess) data.currentExcess = currentExcess;
        if (numberOfClaims) {
            data.numberOfClaims = Number(numberOfClaims);
            data.__hasClaims__ = Number(numberOfClaims) > 0;
        }
        if (valueOfClaims) data.valueOfClaims = valueOfClaims;
        if (propertyInsuranceDeclined) data.propertyInsuranceDeclined = propertyInsuranceDeclined.toUpperCase() === 'TRUE';
        if (coverLimited) data.coverLimited = coverLimited.toUpperCase() === 'TRUE';
        if (streetNumber) data.ownersCorporationAddress.streetNumber = streetNumber;
        if (streetName) data.ownersCorporationAddress.streetName = streetName;
        if (suburb) data.ownersCorporationAddress.suburb = suburb;
        if (state) data.ownersCorporationAddress.state = state;
        if (postcode) data.ownersCorporationAddress.postcode = postcode;
        if (ownersCorporationNumber) data.ownersCorporationNumber = ownersCorporationNumber;
        if (ownersCorporationType) data.ownersCorporationType = ownersCorporationType;
        if (selfManaged) data.selfManaged = selfManaged.toUpperCase() === 'TRUE';

        // set STEP-3 details
        if (buildingSumInsured) data.buildingSumInsured = buildingSumInsured;
        if (contentsSumInsured) data.contentsSumInsured = contentsSumInsured;
        if (lossOfRentPercent) data.lossOfRentPercent = Number(lossOfRentPercent);
        if (liabilitySumInsured) data.liabilitySumInsured = Number(liabilitySumInsured);
        if (voluntaryWorkersDeath) data.voluntaryWorkersDeath = Number(voluntaryWorkersDeath);
        if (workersCompensationRequired) data.workersCompensationRequired = workersCompensationRequired.toUpperCase() === 'TRUE';
        if (estimatedWages) data.estimatedWages = estimatedWages;
        if (employeesEstimatedWages) data.employeesEstimatedWages = employeesEstimatedWages;
        if (labourOnlyEstimatedWages) data.labourOnlyEstimatedWages = labourOnlyEstimatedWages;
        if (labourMaterialsEstimatedWages) data.labourMaterialsEstimatedWages = labourMaterialsEstimatedWages;
        if (labourPlantEstimatedWages) data.labourPlantEstimatedWages = labourPlantEstimatedWages;
        if (labourPlantMaterialsEstimatedWages) data.labourPlantMaterialsEstimatedWages = labourPlantMaterialsEstimatedWages;
        if (fidelitySumInsured) data.fidelitySumInsured = Number(fidelitySumInsured);
        if (cyberSumInsured) data.cyberSumInsured = Number(cyberSumInsured);
        if (officeBearersRequired) data.officeBearersRequired = officeBearersRequired.toUpperCase() === 'TRUE';
        if (officeBearersSumInsured) data.officeBearersSumInsured = Number(officeBearersSumInsured);
        if (machineryBreakdownRequired) data.machineryBreakdownRequired = machineryBreakdownRequired.toUpperCase() === 'TRUE';
        if (machineryBreakdownSumInsured) data.machineryBreakdownSumInsured = Number(machineryBreakdownSumInsured);
        if (carStackerTurnTable) data.carStackerTurnTable = carStackerTurnTable.toUpperCase() === 'TRUE';
        if (airConditioningLocation) data.airConditioningLocation = airConditioningLocation;
        if (electronicMotors5KW) data.electronicMotors5KW = electronicMotors5KW.toUpperCase() === 'TRUE';
        if (chillersOrCoolingTowers) data.chillersOrCoolingTowers = chillersOrCoolingTowers.toUpperCase() === 'TRUE';
        if (twentyYearOldPlus) data.twentyYearOldPlus = twentyYearOldPlus.toUpperCase() === 'TRUE';
        if (catastropheRequired) data.catastropheRequired = catastropheRequired.toUpperCase() === 'TRUE';
        if (catastrophePercent) data.catastrophePercent = Number(catastrophePercent);
        if (floodRequested) data.floodRequested = floodRequested.toUpperCase() === 'TRUE';
        if (lotOwnerContentsSumInsured) data.lotOwnerContentsSumInsured = lotOwnerContentsSumInsured;

        // set STEP-4 details
        if (buildingName) data.buildingName = buildingName;
        if (yearBuilt) data.yearBuilt = yearBuilt;
        if (yearRewired) data.yearRewired = yearRewired;
        if (yearReplumbed) data.yearReplumbed = yearReplumbed;
        if (yearRefurbished) data.yearRefurbished = yearRefurbished;
        if (heritageListed) data.heritageListed = heritageListed.toUpperCase() === 'TRUE';
        if (numberOfLots) data.numberOfLots = Number(numberOfLots);
        if (numberOfResidentialLots) data.numberOfResidentialLots = Number(numberOfResidentialLots);
        if (numberOfFloors) data.numberOfFloors = Number(numberOfFloors);
        if (numberOfBasements) data.numberOfBasements = Number(numberOfBasements);
        if (equipmentInBasements) data.equipmentInBasements = equipmentInBasements.toUpperCase() === 'TRUE';
        if (commerciallyUsed) data.commerciallyUsed = commerciallyUsed.toUpperCase() === 'TRUE';
        if (knownDefects) data.knownDefects = knownDefects.toUpperCase() === 'TRUE';
        if (wallConstruction) data.wallConstruction = wallConstruction;
        if (roofConstruction) data.roofConstruction = roofConstruction;
        if (floorConstruction) data.floorConstruction = floorConstruction;
        if (epsPercent) data.epsPercent = epsPercent;
        if (aluminiumCompositePanels) data.aluminiumCompositePanels = aluminiumCompositePanels.toUpperCase() === 'TRUE';
        
        // set STEP-5 details
        if (numberOfLifts) data.numberOfLifts = numberOfLifts;
        if (numberOfPoolsOrSpas) data.numberOfPoolsOrSpas = numberOfPoolsOrSpas;
        if (hasPlayground) data.hasPlayground = hasPlayground.toUpperCase() === 'TRUE';
        if (jettyWharfPontoonMarina) data.jettyWharfPontoonMarina = jettyWharfPontoonMarina.toUpperCase() === 'TRUE';
        if (lakePondWaterway) data.lakePondWaterway = lakePondWaterway.toUpperCase() === 'TRUE';
        if (gymUsedByPublic) data.gymUsedByPublic = gymUsedByPublic.toUpperCase() === 'TRUE';
        if (fullyOccupied) data.fullyOccupied = fullyOccupied.toUpperCase() === 'TRUE';
        if (groundFloorOccupancy) data.groundFloorOccupancy = groundFloorOccupancy;
        if (fireExtinguishers) data.fireExtinguishers = fireExtinguishers.toUpperCase() === 'TRUE';
        if (fireHydrantsHoseReels) data.fireHydrantsHoseReels = fireHydrantsHoseReels.toUpperCase() === 'TRUE';
        if (fireAlarm) data.fireAlarm = fireAlarm.toUpperCase() === 'TRUE';
        if (sprinklersLocation) data.sprinklersLocation = sprinklersLocation;
        if (strataManagementCompanyName) data.strataManagementCompanyName = strataManagementCompanyName;
        if (strataManagerContactFullName) data.strataManagerContact.fullName = strataManagerContactFullName;
        if (strataManagerContactPhone) data.strataManagerContact.phone = strataManagerContactPhone;
        if (strataManagerContactEmail) data.strataManagerContact.email = strataManagerContactEmail;

        // set STEP-6 details
        if (propertyExcess) data.propertyExcess = Number(propertyExcess);
        if (waterDamageExcess) data.waterDamageExcess = Number(waterDamageExcess);

        return {
            ...data
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/routes/step-1.tsx